import {convertUTCToLocal} from '@/utility/dateHelper'

export const GetFormattedActivityData = (apiResponse = {}) => {
  const {
    data,
    totalRecords = '',
    totalPages = '',
    pageSize = '',
    currentPage = '',
    activeCount = '',
    sortBy = '',
    order = '',
  } = apiResponse

  const formattedActivityData = data?.map(GetActivityData)

  return {
    data: formattedActivityData,
    totalRecords,
    totalPages,
    pageSize,
    currentPage,
    activeCount,
    sortBy,
    order,
  }
}

// Helper function to map individual items
const GetActivityData = (item = {}) => {
  const {
    activityId = null,
    activityTitle = '',
    customersCount = 0,
    percentCompleted = 0,
    pointsAwarded = 0,
    updatedBy = '',
    status = '',
    lastUpdatedDate,
    uuid = null,
  } = item

  return {
    id: activityId,
    activityTitle,
    customersCount,
    percentCompleted,
    pointsAwarded,
    updatedBy,
    status,
    lastUpdatedDate: convertUTCToLocal(lastUpdatedDate),
    uuid,
  }
}
